import React from 'react'
import "../Style/policy.css"

const Policy = () => {
  return (
    <div className='container'>
      <h1>Privacy Policy</h1>
      <div className='content-container'>
        <p><span>1.</span> Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae quibusdam voluptatum? Dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae</p>
        <p><span>2.</span> Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae quibusdam voluptatum? Dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae
        </p>
        <p><span>3.</span> Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae quibusdam voluptatum?
        Dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae
        </p>
        <p><span>4.</span> Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae quibusdam voluptatum?
        Dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae
        </p>
        <p><span>5.</span> Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae quibusdam voluptatum?
        Dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae
        </p>
        <p><span>6.</span> Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae quibusdam voluptatum?
        Dolor sit amet consectetur adipisicing elit. v
        </p>
        <p><span>7.</span> Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae quibusdam voluptatum?
        Dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae
        </p>
        <p><span>8.</span> Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae quibusdam voluptatum?
        Dolor sit amet consectetur adipisicing elit. Dicta, necessitatibus tempora. Delectus porro veritatis illo ullam eaque beatae
        </p>
      </div>
    </div>
  )
}

export default Policy
